import { Check, Close } from "@mui/icons-material";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";
import { TransitionAnimation } from "../Animations/TransitionAnimation";
import { KeyDrivePrimaryButton } from "../Buttons/KeyDrivePrimaryButton";
import { KeyDriveSecondaryButton } from "../Buttons/KeyDriveSecondaryButton";
import { KeyDriveBodyMin } from "../Fonts/Body/KeyDriveBodyMin";


export interface IKeyDriveDialogButtons {
    leftButtonText?: string;
    rightButtonText?: string;
    leftButtonMethod?: () => void;
    rightButtonMethod: () => void;
}

export interface IKeyDriveDialogContent {
    dialogTitle?: string;
    dialogContent?: string | React.ReactNode;
    dialogIcon?: React.ReactNode;
    openDialog: boolean;
    handleTogglDialog: () => void;
}

export interface IKeyDriveDialog {
    keyDriveDialogButtons: IKeyDriveDialogButtons;
    keyDriveDialogContent: IKeyDriveDialogContent;
    dialogTitleCenter?: boolean;
    hidden?: boolean;
}

export const KeyDriveDialog: React.FC<IKeyDriveDialog> = ({
    keyDriveDialogButtons: {
        leftButtonMethod,
        leftButtonText,
        rightButtonMethod,
        rightButtonText
    },
    keyDriveDialogContent: {
        dialogContent,
        dialogIcon,
        dialogTitle,
        handleTogglDialog,
        openDialog
    },
    dialogTitleCenter,
    hidden
}) => {
  
    
    return (
        <Dialog
            open={openDialog}
            TransitionComponent={TransitionAnimation}
            keepMounted
            onClose={handleTogglDialog}
            aria-describedby="alert-dialog-slide-description"
            PaperProps={{
                sx: {
                    borderRadius: "10px",
                    paddingBottom: "30px",
                    paddingTop: "30px"
                }
            }}
            hidden={hidden}
        >
            <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                { dialogIcon }
            </Box>
            <DialogTitle
                sx={{
                    textAlign: `${dialogTitleCenter ? "center" : "none"}`,
                    font: "normal normal 600 20px/39px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                }}
            >
                { dialogTitle }
            </DialogTitle>
            <DialogContent sx={{paddingX: "30px"}}>
                { typeof dialogContent == "string" ? (
                    <Typography
                        sx={{
                            textAlign: "center",
                            letterSpacing: "0px",
                            color: "#575757",
                            opacity: 1,
                        }}
                    >
                        { dialogContent }
                    </Typography>
                ) : (
                    <>
                        { dialogContent }
                    </>
                ) }
            </DialogContent>
            <DialogActions
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    paddingX: "30px"
                }}
            >
                { leftButtonText != undefined &&
                    <KeyDriveSecondaryButton 
                    onClick={leftButtonMethod}
                    TextComponent={KeyDriveBodyMin}
                    TextComponentProps={{
                        color: "#22638D",
                        needBold: false,
                        needEllipses: false,
                        text: leftButtonText
                    }}
                    disabled={false}
                    startIcon={<Close />}
                    height="36px"
                    needFullWidth
                />}
                { rightButtonText != undefined && (
                    <KeyDrivePrimaryButton 
                        onClick={rightButtonMethod}
                        TextComponent={KeyDriveBodyMin}
                        TextComponentProps={{
                            color: "",
                            needBold: false,
                            needEllipses: false,
                            text: rightButtonText
                        }}
                        disabled={false}
                        startIcon={<Check />}
                        height="36px"
                        needFullWidth
                    />
                ) }
            </DialogActions>
        </Dialog>
    )
}